// FeaturePlacementMenu.tsx — Floating feature-type picker shown on double-click/long-press
import type { SlotGroupKey } from '../utils/slotUtils';
import './FeaturePlacementMenu.css';

interface Props {
  screenX: number;
  screenY: number;
  onSelect: (group: SlotGroupKey) => void;
  onCancel: () => void;
}

interface Category {
  label: string;
  items: { group: SlotGroupKey; label: string }[];
}

const CATEGORIES: Category[] = [
  {
    label: 'Openings',
    items: [
      { group: 'rovar', label: 'Rough Opening' },
      { group: 'wdvar', label: 'Window' },
      { group: 'drvar', label: 'Man Door' },
      { group: 'dlvar', label: 'Dock Leveler' },
      { group: 'sbvar', label: 'Rect Blockout' },
      { group: 'rbvar', label: 'Round Blockout' },
    ],
  },
  {
    label: 'Features',
    items: [
      { group: 'fhvar', label: 'Horizontal Feature' },
      { group: 'fvvar', label: 'Vertical Feature' },
    ],
  },
  {
    label: 'Structure',
    items: [
      { group: 'plvar', label: 'Pilaster' },
    ],
  },
  {
    label: 'Connections',
    items: [
      { group: 'bpvar', label: 'Brace Point' },
      { group: 'ppvar', label: 'Pick Point' },
      { group: 'wcvar', label: 'Weld Connection' },
    ],
  },
];

export default function FeaturePlacementMenu({ screenX, screenY, onSelect, onCancel }: Props) {
  return (
    <div className="fpm-backdrop" onMouseDown={onCancel} onContextMenu={e => { e.preventDefault(); onCancel(); }}>
      <div
        className="feature-placement-menu"
        style={{ left: screenX, top: screenY }}
        onMouseDown={e => e.stopPropagation()}
      >
        <div className="fpm-header">Add Feature</div>
        {CATEGORIES.map(cat => (
          <div key={cat.label} className="fpm-category">
            <div className="fpm-cat-label">{cat.label}</div>
            {cat.items.map(item => (
              <button
                key={item.group}
                className="fpm-item"
                onClick={() => onSelect(item.group)}
              >
                {item.label}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
